import React, { useCallback, useEffect, useState } from "react";
import { RadioButtonOption, RadioButtonProps } from "./types";

const RadioButton: React.FC<RadioButtonProps> = (props: RadioButtonProps) => {
  const { name, value, options, onChange } = props;

  const [selectedOption, setSelectedOption] = useState<string>("");

  useEffect(() => {
    if (value) setSelectedOption(value);
  }, [value]);

  const handleChange = useCallback(
    (selectedOption: RadioButtonOption) => {
      setSelectedOption(selectedOption.value);
      onChange(name, selectedOption);
    },
    [onChange]
  );


  return (
    <div className="flex justify-center">
      {options.map((option) => {
        return (
          <div
            key={option.value}
            className="mb-[0.125rem] me-4 inline-block min-h-[1.5rem] ps-[1.5rem]"
          >
            <input
              className="relative 
                        float-left 
                        -ms-[1.5rem] 
                        me-1 
                        mt-0.5 
                        h-5 
                        w-5 
                        appearance-none 
                        rounded-full 
                        border-2 
                        border-solid 
                        border-slate-300

                        before:pointer-events-none 
                        before:absolute 
                        before:h-4 
                        before:w-4 
                        before:scale-0 
                        before:rounded-full 
                        before:bg-transparent 
                        before:opacity-0 
                        before:shadow-checkbox 
                        before:shadow-transparent 
                        before:content-[''] 

                        after:absolute 
                        after:z-[1] 
                        after:block 
                        after:h-4 
                        after:w-4 
                        after:rounded-full 
                        after:content-[''] 

                        checked:border-slate-300
                        checked:before:opacity-[0.16] 
                        checked:after:absolute 
                        checked:after:left-1/2 
                        checked:after:top-1/2 
                        checked:after:h-[0.625rem] 
                        checked:after:w-[0.625rem] 
                        checked:after:rounded-full 
                        checked:after:border-slate-300
                        checked:after:bg-blue-500 
                        checked:after:content-[''] 
                        checked:after:[transform:translate(-50%,-50%)] 

                        hover:cursor-pointer 
                        hover:before:opacity-[0.04] 
                        hover:before:shadow-black/60 

                        focus:shadow-none 
                        focus:outline-none 
                        focus:ring-0
                        focus:before:scale-100 
                        focus:before:opacity-[0.12] 
                        focus:before:shadow-black/60 
                        focus:before:transition-[box-shadow_0.2s,transform_0.2s] 

                        checked:focus:border-slate-300
                        checked:focus:before:scale-100 
                        checked:focus:before:shadow-checkbox 
                        checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        "
              type="radio"
              name={name}
              id={option.value}
              value={option.value}
              checked={selectedOption === option.value}
              onChange={() => !option.disabled && handleChange(option)}
              disabled={option.disabled}
            />
            <label
              className={`mt-px inline-block ps-[0.15rem] ${
                option.disabled
                  ? "opacity-50 hover:pointer-events-none"
                  : "hover:cursor-pointer"
              }`}
              htmlFor={option.value}
            >
              {option.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default RadioButton;
